import type { RegistryService } from "../../design/services";
import { Registry as Base } from "./shared";

export class Registry extends Base {
    async set(service: RegistryService): Promise<void> {
        this.services.set(service.name, service.methods);
    }
}
